import { useState } from "react";
import { useTranslation } from "react-i18next";
import DateInputField from "../Common/InputField/DateInputField";
import TimeInputField from "../Common/InputField/TimeInputField";
import axios from "axios";
import { env } from "../../env";
import moment from "moment";
import TimeRangePicker from "../Common/InputField/TimeRangePickerComponent";
import DateRangePicker from "../Common/InputField/DateRangePickerComponent";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AgreementFormPopUpComponent = ({customerId, sendModalCloseDataFromChild, headerDetail, headerListDetail}) => {
    const { t } = useTranslation();
   
    const formSchema = headerDetail;
    const [showAll, setShowAll] = useState(false);
    const [showForm, setShowForm] = useState("");
    const [tabName, setTabName] = useState("headers");
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();

    const hangleModalClose = (e) => {
        e.preventDefault();
        if(Object.keys(formData).length > 0) {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("if you click yes, you will lost all the data of the form")}!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t("yes")}!`,
                cancelButtonText: `${ t("cancel")}!`
            }).then((result) => {
                if (result.isConfirmed) { 
                    sendModalCloseDataFromChild(false);
                }
            });
        } else {
            sendModalCloseDataFromChild(false);
        }
    };
    const handleCollapseAll = (e) => {
        setShowAll(false);
        setShowForm("");
    };
    const handleShowForm = (index) => {
        if(showForm === index) {
            setShowForm("");
        } else {
            setShowForm(index);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (value === '' || value === null) {
            setFormData(prevFormData => {
                const { [name]: _, ...rest } = prevFormData;
                return rest;
            });
        } else {
            setFormData({
                ...formData,
                [name]: {
                    Id: formSchema.find(field => field.Id == name)?.Id || '',
                    Description: formSchema.find(field => field.Id == name)?.Description || '',
                    Line_Type: formSchema.find(field => field.Id == name)?.Line_Type || '',
                    Is_Visible_To_Customer: (formSchema.find(field => field.Id == name)?.Is_Visible_To_Customer ? 1 : 0) || '',
                    Title: formSchema.find(field => field.Id == name)?.Title || '',
                    Value: value,
                },
            });
        }
    };
    const handleNumberChange = (e) => {
        const { name, value } = e.target;

        if(formSchema.find(field => field.Id == name)?.Number_Format > 0) {
            var decimalLimit = (formSchema.find(field => field.Id == name)?.Number_Format) - 1;
        } else {
            var decimalLimit = 0;
        }

        if (value === '' || value === null) {
            setFormData(prevFormData => {
                const { [name]: _, ...rest } = prevFormData;
                return rest;
            });
        } else {
            const decimalRegex = new RegExp(`^\\d*(\\.\\d{0,${decimalLimit}})?$`);
            if (decimalRegex.test(value) || value === '') {
                setFormData({
                    ...formData,
                    [name]: {
                        Id: formSchema.find(field => field.Id == name)?.Id || '',
                        Description: formSchema.find(field => field.Id == name)?.Description || '',
                        Line_Type: formSchema.find(field => field.Id == name)?.Line_Type || '',
                        Is_Visible_To_Customer: (formSchema.find(field => field.Id == name)?.Is_Visible_To_Customer ? 1 : 0) || '',
                        Title: formSchema.find(field => field.Id == name)?.Title || '',
                        Value: value,
                    },
                });
            }
        }
    };
    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        formSchema.find(field => field.Id == name)?.scale_option.map((option, index) => {
            if(value == index) {
                option.Value = 1;
            } else {
                option.Value = 0;
            }
        });

        setFormData({
          ...formData,
            [name]: { 
                Id: formSchema.find(field => field.Id == name)?.Id || '',
                Description: formSchema.find(field => field.Id == name)?.Description || '',
                Line_Type: formSchema.find(field => field.Id == name)?.Line_Type || '',
                Is_Visible_To_Customer: (formSchema.find(field => field.Id == name)?.Is_Visible_To_Customer ? 1 : 0) || '',
                Title: formSchema.find(field => field.Id == name)?.Title || '',
                Scales: formSchema.find(field => field.Id == name)?.scale_option || ''
            },
        });
    };
    const handleBooleanChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
            [name]: { 
                Id: formSchema.find(field => field.Id == name)?.Id || '',
                Description: formSchema.find(field => field.Id == name)?.Description || '',
                Line_Type: formSchema.find(field => field.Id == name)?.Line_Type || '',
                Is_Visible_To_Customer: (formSchema.find(field => field.Id == name)?.Is_Visible_To_Customer ? 1 : 0) || '',
                Title: formSchema.find(field => field.Id == name)?.Title || '',
                Value: value
            },
        });
    };
    const handleDateDataFromChild = (data) => {
        setFormData({
            ...formData,
              [data.id]: { 
                  Id: formSchema.find(field => field.Id == data.id)?.Id || '',
                  Description: formSchema.find(field => field.Id == data.id)?.Description || '',
                  Line_Type: formSchema.find(field => field.Id == data.id)?.Line_Type || '',
                  Is_Visible_To_Customer: formSchema.find(field => field.Id == data.id)?.Is_Visible_To_Customer || '',
                  Title: formSchema.find(field => field.Id == data.id)?.Title || '',
                  Value: moment(data.date).format("DD/MM/YYYY")
              },
          });
    };
    const handleTimeDataFromChild = (data) => {
        setFormData({
            ...formData,
            [data.id]: { 
                Id: formSchema.find(field => field.Id == data.id)?.Id || '',
                Description: formSchema.find(field => field.Id == data.id)?.Description || '',
                Line_Type: formSchema.find(field => field.Id == data.id)?.Line_Type || '',
                Is_Visible_To_Customer: formSchema.find(field => field.Id == data.id)?.Is_Visible_To_Customer || '',
                Title: formSchema.find(field => field.Id == data.id)?.Title || '',
                Value: moment(data.time).format("hh:mm A")
            },
          });
    };
    const handleTimeRangeDataFromChild = (data) => {
        if(data.start) {
            setFormData({
                ...formData,
                [data.id]: { 
                    Id: formSchema.find(field => field.Id == data.id)?.Id || '',
                    Description: formSchema.find(field => field.Id == data.id)?.Description || '',
                    Line_Type: formSchema.find(field => field.Id == data.id)?.Line_Type || '',
                    Is_Visible_To_Customer: formSchema.find(field => field.Id == data.id)?.Is_Visible_To_Customer || '',
                    Title: formSchema.find(field => field.Id == data.id)?.Title || '',
                    Value: {"startTime": moment(data.start.$d).format("hh:mm A")}
                },
            });
        }
        if(data.start && data.end) {
            setFormData({
                ...formData,
                [data.id]: { 
                    Id: formSchema.find(field => field.Id == data.id)?.Id || '',
                    Description: formSchema.find(field => field.Id == data.id)?.Description || '',
                    Line_Type: formSchema.find(field => field.Id == data.id)?.Line_Type || '',
                    Is_Visible_To_Customer: formSchema.find(field => field.Id == data.id)?.Is_Visible_To_Customer || '',
                    Title: formSchema.find(field => field.Id == data.id)?.Title || '',
                    Value: {"startTime": moment(data.start.$d).format("hh:mm A"),"endTime": moment(data.end.$d).format("hh:mm A")}
                },
            });
        }
    };
    const handleDateRangeDataFromChild = (data) => {
        if(data.start) {
            setFormData({
                ...formData,
                [data.id]: { 
                    Id: formSchema.find(field => field.Id == data.id)?.Id || '',
                    Description: formSchema.find(field => field.Id == data.id)?.Description || '',
                    Line_Type: formSchema.find(field => field.Id == data.id)?.Line_Type || '',
                    Is_Visible_To_Customer: formSchema.find(field => field.Id == data.id)?.Is_Visible_To_Customer || '',
                    Title: formSchema.find(field => field.Id == data.id)?.Title || '',
                    Value: {"startDate": moment(data.start.$d).format("DD/MM/YYYY")}
                },
            });
        }
        if(data.start && data.end) {
            setFormData({
                ...formData,
                [data.id]: { 
                    Id: formSchema.find(field => field.Id == data.id)?.Id || '',
                    Description: formSchema.find(field => field.Id == data.id)?.Description || '',
                    Line_Type: formSchema.find(field => field.Id == data.id)?.Line_Type || '',
                    Is_Visible_To_Customer: formSchema.find(field => field.Id == data.id)?.Is_Visible_To_Customer || '',
                    Title: formSchema.find(field => field.Id == data.id)?.Title || '',
                    Value: {"startDate": moment(data.start.$d).format("DD/MM/YYYY"),"endDate": moment(data.end.$d).format("DD/MM/YYYY")}
                },
            });
        }
    };
    const handleFinalSubmit = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to enrol new agreement")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {  
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');      
                const requestData = {
                    "Contract_Id": headerListDetail.Id,
                    "Customer_Id": parseInt(customerId),
                    "Transaction_Type": 1,
                    "Contract_Detail_JsonData": ""
                }

                axios.post(baseUrl+"/api/OfflineSync/EnrollToNewAgreement", requestData, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    }
                }).then((response) => {
                    if(response.data.success) {
                        sendModalCloseDataFromChild(false);
                        navigate(`/profiles/detail/${customerId}`);
                    }
                }).catch((error) => {
                    console.log(error);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const valuesArray = Object.values(formData);
        const updatedAray = [];
        valuesArray.map((value, index) => {
            // if(value.Line_Type == 'Number') {
            //     value.Value = parseFloat(value.Value).toFixed((formSchema.find(field => field.Id == value.Id)?.Number_Format) - 1);
            // }
            updatedAray.push(value);
        });

        if(Object.keys(formData).length === headerDetail.length) {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("you want to enrol new agreement")}!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t("yes")}!`,
                cancelButtonText: `${ t("cancel")}!`
            }).then((result) => {
                if (result.isConfirmed) {        
                    const baseUrl = env.REACT_APP_API_URL;
                    const token = localStorage.getItem('token');
                    const requestData = {
                        "Contract_Id": headerDetail[0].Contract_Header_Id,
                        "Customer_Id": parseInt(customerId),
                        "Transaction_Type": 1,
                        "Contract_Detail_JsonData": JSON.stringify(updatedAray)
                    }

                    axios.post(baseUrl+"/api/OfflineSync/EnrollToNewAgreement", requestData, {
                        headers : {
                            "Accept" : "Application/json",
                            "Content-Type" : "Application/json",
                            "Authorization" : `Bearer ${token}`
                        }
                    }).then((response) => {
                        if(response.data.success) {
                            sendModalCloseDataFromChild(false);
                            navigate(`/profiles/detail/${customerId}`);
                        }
                    }).catch((error) => {
                        console.log(error);
                        if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                            localStorage.removeItem("token");
                            localStorage.removeItem("userInfo");
                            window.location.reload();
                        }
                    });
                }
            });
        }
    };
    
    return (
        <div className="bg-white p-2 sm:p-4 space-y-2 rounded-xl sm:rounded-none">
            {/* heading */}
            <div className="flex justify-between items-center cursor-pointer">
                <div className="font-semibold text-xs sm:text-lg capitalize w-[50%]">{headerListDetail.Contract_Title}</div>
                <div className="flex justify-between items-center space-x-6">
                    {(!headerListDetail.Needs_Scanning && tabName === "contract-details") ? (
                        <div className="text-blue-normal capitalize flex space-x-2 sm:space-x-4 text-sm font-semibold">
                            <div onClick={(e) => setShowAll(true)} className="text-[10px] sm:text-sm cursor-pointer w-12 sm:w-auto">{ t('expand all')}</div>
                            <div onClick={(e) => handleCollapseAll(e)} className="text-[10px] sm:text-sm cursor-pointer w-13 sm:w-auto">{ t('collapse all')}</div>
                        </div>
                        ) : null
                    }
                    <div className="hidden sm:block" onClick={(e) => hangleModalClose(e)}>
                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                    </div>
                </div>
            </div>
            <div className="rounded-xl bg-white border border-background-normal p-1 flex space-x-4">
                <div onClick={(e) => setTabName("headers")} className={(tabName === "headers" ? "bg-gray-dark3" : "text-light-400") +" capitalize font-semibold text-xs sm:text-sm cursor-pointer px-4 sm:px-6 py-2 rounded-lg"}>{t('headers')}</div>
                <div onClick={(e) => setTabName("terms")} className={(tabName === "terms" ? "bg-gray-dark3" : "text-light-400") +" capitalize font-semibold text-xs sm:text-sm cursor-pointer px-4 sm:px-6 py-2 rounded-lg"}>{t('terms')}</div>
                <div onClick={(e) => setTabName("contract-details")} className={(tabName === "contract-details" ? "bg-gray-dark3" : "text-light-400") +" capitalize font-semibold text-xs sm:text-sm cursor-pointer px-4 sm:px-6 py-2 rounded-lg"}>{t('contract details')}</div>
            </div>
            <form onSubmit={(e) => handleSubmit(e)} className="space-y-2">
                <div className="min-h-56 sm:min-h-[17rem] max-h-64 sm:max-h-96 overflow-y-auto no-scrollbar">
                    {(tabName === "headers") ?
                        <div className="space-y-2">
                            <div className="rounded-xl bg-white border border-background-normal p-2 space-y-1">
                                <h1 className="font-semibold capitalize text-xs sm:text-sm">{ t('description')}</h1>
                                <div className="text-light-400 text-[10px] sm:text-xs">{headerListDetail.Contract_Description}</div>
                            </div>
                            <div className="rounded-xl bg-white border border-background-normal p-2">
                                <h1 className="font-semibold capitalize text-xs sm:text-sm">{ t('general details')}</h1>
                                <div className="divide-y divide-dashed">
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('start date')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{headerListDetail.Start_Date}</div>
                                    </div>
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('end date')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{headerListDetail.End_Date}</div>
                                    </div>
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('needs scanning')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{headerListDetail.Needs_Scanning ? "Yes" : "No"}</div>
                                    </div>
                                    {headerListDetail.Needs_Scanning ?
                                        <div className="flex justify-between items-center py-1 sm:py-1.5">
                                            <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('on quantity')}</div>
                                            <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{headerListDetail.On_Quantity ? 'yes' : 'no'}</div>
                                        </div>
                                    :null}
                                    {headerListDetail.Needs_Scanning ?
                                        <div className="flex justify-between items-center py-1 sm:py-1.5">
                                            <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('target on quantity')}</div>
                                            <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{headerListDetail.Target_On_Qty ? 'yes' : 'no'}</div>
                                        </div>
                                    :null}
                                    <div className="flex justify-between items-center pt-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('reward type')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{headerListDetail.Reward_Type}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : null}
                    {(tabName === "terms") ?
                        <div dangerouslySetInnerHTML={{ __html: headerListDetail.Contract_Terms }} className="rounded-xl bg-white border border-background-normal p-2 space-y-4"></div>
                    : null}
                    {(tabName === "contract-details" && headerListDetail.Needs_Scanning) ?
                        <div className="space-y-2">
                            <div className="rounded-xl bg-white border border-background-normal py-2 px-4 sm:grid sm:grid-cols-8 space-y-2 sm:space-y-0">
                                <div className="sm:col-span-4">
                                    <h1 className="font-medium text-xs sm:text-sm capitalize">{t('caption')}</h1>
                                    <p className="text-light-400 text-[10px] sm:text-xs">{headerListDetail.Caption}</p>
                                </div>
                                <div className="border border-background-normal text-center w-fit"></div>
                                <div className="text-left sm:col-span-3">
                                    <h1 className="font-medium text-xs sm:text-sm capitalize">{t('description')}</h1>
                                    <p className="text-light-400 text-[10px] sm:text-xs">{headerListDetail.Description}</p>
                                </div>
                            </div>
                            <div className="text-xs space-y-1 overflow-x-auto no-scrollbar">
                                <div className="grid grid-cols-6 gap-4 p-2 italic text-gray-dark4">
                                    <h1 className="col-span-3 capitalize">{ t('rewards description')}</h1>
                                    <h1 className="text-center capitalize">{ t('from range')}</h1>
                                    <h1 className="text-center capitalize">{ t('to range')}</h1>
                                    <h1 className="text-center capitalize">{ t('rewards')}</h1>
                                </div>
                                {headerListDetail.Contract_Detail_Scale_JSON ?
                                    headerListDetail.Contract_Detail_Scale_JSON.map((contract, index) => (
                                        <div key={`contract${index}`} className="bg-blue-light grid grid-cols-6 gap-4 p-2">
                                            <div className="col-span-3">{contract.Reward_Description}</div>
                                            <div className="text-center">{contract.From_Range}</div>
                                            <div className="text-center">{contract.To_Range}</div>
                                            <div className="text-center">{contract.Reward}</div>
                                        </div>
                                    ))
                                : null}
                            </div>
                        </div>
                    : null}
                    {(tabName === "contract-details" && !headerListDetail.Needs_Scanning) ?
                        headerDetail.length > 0 ?
                            <div className="space-y-2 max-h-80 sm:max-h-96 overflow-y-auto no-scrollbar">
                                {headerDetail.map((detail, index) => (
                                    <div key={`detail${index}`} className="border border-gray-dark1 rounded-lg p-2 w-full">
                                        <div className="flex justify-between items-center cursor-pointer" onClick={(e) => handleShowForm(index)}>
                                            <div className="font-medium flex items-center text-xs sm:text-base">
                                                {index+1}. <div className="first-letter:capitalize ml-1">{detail.Title}</div>
                                            </div>
                                            <div className="space-x-4 items-center flex">
                                                {(detail.Line_Type === 'Scale') ? 
                                                    ((Object.keys(formData).length > 0) && formData[detail.Id]?.Scales.length > 0) ? 
                                                        <div>
                                                            <img src="../../../assets/icons/profile/tick.svg" alt="tick" />
                                                        </div>
                                                    : null
                                                :null}
                                                {(detail.Line_Type === 'Number' || detail.Line_Type === 'Percentage' || detail.Line_Type === 'Text' || detail.Line_Type === 'Boolean' || detail.Line_Type === 'Date' || detail.Line_Type === 'Time') ? 
                                                    ((Object.keys(formData).length > 0) && formData[detail.Id]?.Value.length > 0) ? 
                                                        <div>
                                                            <img src="../../../assets/icons/profile/tick.svg" alt="tick" />
                                                        </div>
                                                    : null
                                                :null}
                                                {(detail.Line_Type === 'Date Range') ? 
                                                    ((Object.keys(formData).length > 0) && formData[detail.Id]?.Value.startDate && formData[detail.Id]?.Value.endDate) ? 
                                                        <div>
                                                            <img src="../../../assets/icons/profile/tick.svg" alt="tick" />
                                                        </div>
                                                    : null
                                                :null}
                                                {(detail.Line_Type === 'Time Range') ? 
                                                    ((Object.keys(formData).length > 0) && formData[detail.Id]?.Value.startTime && formData[detail.Id]?.Value.endTime) ? 
                                                        <div>
                                                            <img src="../../../assets/icons/profile/tick.svg" alt="tick" />
                                                        </div>
                                                    : null
                                                :null}
                                                <div>
                                                    <img className="w-4 h-4" src={`../../../assets/icons/select-${(showForm === index || showAll) ? 'up' : 'down'}.svg`} alt="arrow" />
                                                </div>
                                            </div>
                                        </div>
                                        {(showForm === index || showAll) ?
                                            <div className="space-y-1">
                                                <h1 className="text-gray-dark4 text-xs sm:text-sm">
                                                    {detail.Description}
                                                </h1>
                                                {(detail.Line_Type === 'Scale' && detail.scale_option) ? 
                                                    <div className="text-xs space-y-1">
                                                        <div className="grid grid-cols-6 gap-4 p-2 italic text-gray-dark4">
                                                            <h1 className="col-span-2 capitalize">{ t('description')}</h1>
                                                            <h1 className="capitalize">{ t('from')}</h1>
                                                            <h1 className="capitalize">{ t('to')}</h1>
                                                            <h1 className="capitalize">{ t('rewards')}</h1>
                                                            <h1 className="capitalize">{ t('select')}</h1>
                                                        </div>
                                                        {detail.scale_option.map((option, index1) => (
                                                            <div key={`option${index1}`} className="bg-blue-light grid grid-cols-6 gap-4 p-2">
                                                                <div className="col-span-2">{option.Reward_Description}</div>
                                                                <div>{option.From_Range}</div>
                                                                <div>{option.To_Range}</div>
                                                                <div>{option.Reward}</div>
                                                                <div className="inline-flex items-center">
                                                                    <label className="relative flex items-center cursor-pointer" htmlFor={option.Reward}>
                                                                        <input
                                                                            className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-400 checked:border-blue-normal bg-white transition-all"
                                                                            id={option.Reward}
                                                                            value={index1}
                                                                            type="radio"
                                                                            name={detail.Id}
                                                                            checked={formData[detail.Id]?.Scales[index1].Value == 1}
                                                                            onChange={handleRadioChange}
                                                                        />
                                                                        <span className="absolute bg-blue-normal w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Number' || detail.Line_Type === 'Percentage') ? 
                                                    <div className="text-xs space-y-1">
                                                        <input className="bg-blue-light p-2 placeholder:capitalize focus:outline-none rounded-lg" value={formData[detail.Id]?.Value || ""} onChange={handleNumberChange} type="number" name={detail.Id} placeholder="enter"/>
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Text') ? 
                                                    <div className="text-xs space-y-1">
                                                        <input className="bg-blue-light p-2 placeholder:capitalize focus:outline-none rounded-lg w-full" value={formData[detail.Id]?.Value || ""} onChange={handleInputChange} type="text" name={detail.Id} placeholder="enter"/>
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Boolean') ? 
                                                    <div className="flex space-x-4">
                                                        <div className="inline-flex items-center space-x-2">
                                                            <label className="relative flex items-center cursor-pointer" htmlFor="true">
                                                                <input
                                                                    name={detail.Id}
                                                                    type="radio"
                                                                    className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-400 checked:border-blue-normal bg-white transition-all"
                                                                    id="true"
                                                                    value={1}
                                                                    checked={formData[detail.Id]?.Value == 1}
                                                                    onChange={handleBooleanChange}
                                                                />
                                                                <span className="absolute bg-blue-normal w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                                                            </label>
                                                            <div className="capitalize">
                                                                { t("true")}
                                                            </div>
                                                        </div>
                                                        <div className="inline-flex items-center space-x-2">
                                                            <label className="relative flex items-center cursor-pointer" htmlFor="false">
                                                                <input
                                                                    name={detail.Id}
                                                                    type="radio"
                                                                    className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-400 checked:border-blue-normal bg-white transition-all"
                                                                    id="false"
                                                                    value={0}
                                                                    checked={formData[detail.Id]?.Value == 0}
                                                                    onChange={handleBooleanChange}
                                                                />
                                                                <span className="absolute bg-blue-normal w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                                                            </label>
                                                            <div className="capitalize">
                                                                { t("false")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Date') ? 
                                                    <div className="w-fit">
                                                        <DateInputField setDataFromChild={handleDateDataFromChild} startDate={null} dateInput={formData[detail.Id]?.Value || null} disableDate={false} week={[]} name={detail.Id}/>
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Date Range') ? 
                                                    <div className="flex items-center sm:space-x-4">
                                                        <DateRangePicker sendDateRangeDataFromChild={handleDateRangeDataFromChild} dateStartInput={formData[detail.Id]?.Value.startDate || null} dateEndInput={formData[detail.Id]?.Value.endDate || null} fromDate={detail.From_Date} toDate={detail.To_Date} name={detail.Id} />
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Time') ? 
                                                    <div className="w-min">
                                                        <TimeInputField sendTimeFromChild={handleTimeDataFromChild} timeInput={formData[detail.Id]?.Value || null} name={detail.Id} />
                                                    </div>
                                                : null}
                                                {(detail.Line_Type === 'Time Range') ? 
                                                    <div className="sm:flex sm:items-center sm:space-x-4 space-y-2 sm:space-y-0">
                                                        <TimeRangePicker sendTimeRangeDataFromChild={handleTimeRangeDataFromChild} timeStartInput={formData[detail.Id]?.Value.startTime || null} timeEndInput={formData[detail.Id]?.Value.endTime || null} name={detail.Id} />
                                                    </div>
                                                : null}
                                            </div>
                                        : null}
                                    </div>
                                ))}
                            </div>
                        :
                        <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white">
                            { t('no records available')}
                        </div>
                    : null}
                </div>
                <div className="flex justify-between items-center pt-4">
                    <button onClick={(e) => hangleModalClose(e)} type="button" className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-light-400 bg-white border border-light-400 rounded-lg tracking-wide capitalize">{ t('close') }</button>
                    {headerListDetail.Needs_Scanning ? 
                        (
                            <button onClick={(e) => handleFinalSubmit(e)} type="button" className="bg-blue-normal border border-blue-normal text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white rounded-lg tracking-wide capitalize">
                                {t('confirm')}
                            </button>
                        ) : tabName === "headers" ? (
                            <button type="button" onClick={(e) => setTabName("terms")} className="bg-blue-normal border border-blue-normal text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white rounded-lg tracking-wide capitalize">
                                {t('next')}
                            </button>
                        ) : tabName === "terms" ? (
                            <div className="flex space-x-4 items-center">
                                <div onClick={(e) => setTabName("headers")} className="flex space-x-2 items-center capitalize cursor-pointer">
                                    <img className="w-3 h-3" src="../../../assets/icons/profile/arrow-left.svg" alt="arrow-left" />
                                    <div className="text-light-400 text-xs font-medium sm:text-lg">{t('back')}</div>
                                </div>
                                <button type="button" onClick={(e) => setTabName("contract-details")} className="bg-blue-normal border border-blue-normal text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white rounded-lg tracking-wide capitalize">
                                    {t('next')}
                                </button>
                            </div>
                        ) : tabName === "contract-details" ? (
                            <div className="flex space-x-4 items-center">
                                <div onClick={(e) => setTabName("terms")} className="flex space-x-2 items-center capitalize cursor-pointer">
                                    <img className="w-3 h-3" src="../../../assets/icons/profile/arrow-left.svg" alt="arrow-left" />
                                    <div className="text-light-400 text-xs font-medium sm:text-lg">{t('back')}</div>
                                </div>
                                <button type={Object.keys(formData).length === headerDetail.length ? "submit" : "button"} className={`${
                                    Object.keys(formData).length === headerDetail.length
                                        ? "bg-blue-normal border border-blue-normal"
                                        : "text-white border-blue-disable cursor-not-allowed bg-blue-disable"
                                    } text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white rounded-lg tracking-wide capitalize`}
                                >
                                    {t('confirm')}
                                </button>
                            </div>
                        ) : null
                    }
                </div>
            </form>
        </div>
    )
}

export default AgreementFormPopUpComponent;